import React, { useEffect, useState } from "react";
import ReactDOM from 'react-dom';

const ModalWrapper = ({children}) => {
  const [ container, setContainer ] = useState(null);
  
  useEffect(() => {
    if(document)
      setContainer(document.querySelector('#___gatsby'));
  },[]);

  return (<>
    {(container) &&
      ReactDOM.createPortal(children, container)}
    </>);
}

export default ModalWrapper;
